import { connect } from 'react-redux'
import { getCounter, getSettingsSavedTitleText } from '../../../../data'
import Status from './component'

function mapStateToProps(state) {
    return {
        text: getSettingsSavedTitleText(state),
        changeCount: getCounter(state),
    }
}

export default connect(mapStateToProps)(Status)



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/Status/index.js